import { z } from 'zod/v4';

import { entityStateSchema } from '../../../schemas/entity-state.schema';
import { roleSchema } from '../../../schemas/role.schema';

export const accountProductRoleSchema = z.object({
  accountId: z.number().min(1),
  userId: z.number().min(1),
  userName: z.string().min(1),
  userState: entityStateSchema,
  accountState: z.number().min(1),
  accountName: z.string().min(1),
  accountAlias: z.string().nullable(),
  expirationDate: z.string().nullable(),
  roleId: z.string().min(1),
  roleName: roleSchema,
  firstName: z.string().min(1),
  lastName: z.string().min(1),
});

export type AccountProductRole = z.infer<typeof accountProductRoleSchema>;
